import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Zap, ArrowUpRight } from "lucide-react";

/**
 * Contextual free-plan upgrade prompt. Renders only for FREE fleets and only
 * when at/over the given limit. `kind` = "machine" | "staff".
 */
export function UpgradeNudge({ kind, current, limit }) {
  const { fleet, isManager } = useAuth();
  if (!fleet || fleet.plan !== "free") return null;
  const cap = limit ?? (kind === "staff" ? 4 : fleet.machine_limit);
  const atLimit = current != null ? current >= cap : (fleet.machine_count >= fleet.machine_limit);
  if (!atLimit) return null;

  const copy = kind === "staff"
    ? { title: "You've hit your free team limit", body: `Free fleets include ${cap} team members. Upgrade to add your whole crew — one plan covers everyone.` }
    : { title: "You've reached your free machine limit", body: `Free fleets track ${cap} machines. Upgrade to add your whole fleet, unlock photos, reminders and QR tags.` };

  return (
    <div className="card p-5 mb-6 border-l-4 border-[#FFB800] flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-testid={`upgrade-nudge-${kind}`}>
      <div className="flex items-start gap-3">
        <Zap className="w-6 h-6 text-[#FFB800] shrink-0" />
        <div>
          <p className="font-head font-800 uppercase tracking-tight">{copy.title}</p>
          <p className="font-body text-sm text-[#94A3B8] mt-1 max-w-xl">{copy.body}</p>
        </div>
      </div>
      {isManager ? (
        <Link to="/billing" className="btn-signal h-12 px-6 font-head flex items-center gap-2 shrink-0" data-testid={`upgrade-nudge-cta-${kind}`}>
          See Plans <ArrowUpRight className="w-5 h-5" strokeWidth={2.5} />
        </Link>
      ) : (
        <span className="font-mono text-xs text-[#94A3B8] shrink-0">Ask your manager to upgrade</span>
      )}
    </div>
  );
}
